import { TextField } from "@material-ui/core";
import _ from "lodash";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";
import ReportByGame from "../ReportByGame";

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function ActionPercentByGame() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [sport, setSport] = useState("");
  const onSportChanged = useCallback((s) => setSport(s), []);
  const { values: sports } = useDataFormatterHook({
    addEmpty: true,
    value: "idSport",
    text: "sportName",
    path: `/Player/GetSports`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Sport"
          name="name"
          data={sports}
          placeholder="DataFormatter"
          setSelectValue={onSportChanged}
          startValue={""}
        />
      </div>
      <ReportByGame
        title="Action Percent by Game Report"
        getUrl={() => "/Reports/Report_Action_Percent_By_Game_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Sport: sport,
        })}
        getPostProcess={(groupedData) => {
          const items = Object.values(groupedData).map((Values) => {
            const [{ idGame, sportOrder, gameDate }] = Values;

            return {
              idGame,
              sportOrder,
              gameDate: new Date(gameDate),
              Values,
            };
          });

          return _.sortBy(items, ["gameDate", "sportOrder", "idGame"]);
        }}
        getProcess={(sport, values) => {
          switch (sport) {
            case "tnt":
              return [values?.[0], ...values].map(
                (
                  {
                    Id,
                    idSport,
                    homeName,
                    visitorName,
                    totalPlay1,
                    chartPlay1,
                    masterChartPlay1,
                  },
                  index
                ) => {
                  if (index === 0) {
                    return {
                      Id: `${Id}V`,
                      sport: idSport,
                      team: visitorName,
                    };
                  } else {
                    return {
                      Id: `${Id}H`,
                      sport: "",
                      team: homeName,
                      first: totalPlay1,
                      firstChart: chartPlay1,
                      firstMaster: masterChartPlay1,
                    };
                  }
                }
              );
            // Soccer
            // MLB
            // MU
            case "mlb":
            case "mu":
            case "soc": {
              const {
                Id,
                idSport,
                homeName,
                visitorName,
                totalPlay0,
                chartPlay0,
                masterChartPlay0,
                totalPlay1,
                chartPlay1,
                masterChartPlay1,
                totalPlay2,
                chartPlay2,
                masterChartPlay2,
                totalPlay3,
                chartPlay3,
                masterChartPlay3,
                totalPlay4,
                chartPlay4,
                masterChartPlay4,
                totalPlay5,
                chartPlay5,
                masterChartPlay5,
                totalPlay6,
                chartPlay6,
                masterChartPlay6,
              } = values?.[0];
              return [
                {
                  Id: `${Id}V`,
                  sport: idSport,
                  team: visitorName,
                  first: totalPlay4,
                  firstChart: chartPlay4,
                  firstMaster: masterChartPlay4,
                  second: totalPlay2,
                  secondChart: chartPlay2,
                  secondMaster: masterChartPlay2,
                  third: totalPlay0,
                  thirdChart: chartPlay0,
                  thirdMaster: masterChartPlay0,
                },
                {
                  Id: `${Id}H`,
                  sport: "",
                  team: homeName,
                  first: totalPlay5,
                  firstChart: chartPlay5,
                  firstMaster: masterChartPlay5,
                  second: totalPlay3,
                  secondChart: chartPlay3,
                  secondMaster: masterChartPlay3,
                  third: totalPlay1,
                  thirdChart: chartPlay1,
                  thirdMaster: masterChartPlay1,
                },
                sport === "soc"
                  ? {
                    Id: `${Id}D`,
                    sport: "",
                    team: "Draw",
                    first: totalPlay6,
                    firstChart: chartPlay6,
                    firstMaster: masterChartPlay6,
                  }
                  : null,
              ].filter(Boolean);
            }

            // nba, cfb, nfl, nhl, cbb
            default: {
              const {
                Id,
                idSport,
                homeName,
                visitorName,
                totalPlay0,
                chartPlay0,
                masterChartPlay0,
                totalPlay1,
                chartPlay1,
                masterChartPlay1,
                totalPlay2,
                chartPlay2,
                masterChartPlay2,
                totalPlay3,
                chartPlay3,
                masterChartPlay3,
                totalPlay4,
                chartPlay4,
                masterChartPlay4,
                totalPlay5,
                chartPlay5,
                masterChartPlay5,
              } = values?.[0];
              return [
                {
                  Id: `${Id}V`,
                  sport: idSport,
                  team: visitorName,
                  first: totalPlay0,
                  firstChart: chartPlay0,
                  firstMaster: masterChartPlay0,
                  second: totalPlay2,
                  secondChart: chartPlay2,
                  secondMaster: masterChartPlay2,
                  third: totalPlay4,
                  thirdChart: chartPlay4,
                  thirdMaster: masterChartPlay4,
                },
                {
                  Id: `${Id}H`,
                  sport: "",
                  team: homeName,
                  first: totalPlay1,
                  firstChart: chartPlay1,
                  firstMaster: masterChartPlay1,
                  second: totalPlay3,
                  secondChart: chartPlay3,
                  secondMaster: masterChartPlay3,
                  third: totalPlay5,
                  thirdChart: chartPlay5,
                  thirdMaster: masterChartPlay5,
                },
              ];
            }
          }
        }}
        columnDef={(sport) => {
          switch (sport) {
            case "tnt":
              return [
                <TableHeaderColumn dataField="Id" isKey hidden>
                  Id
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="sport">Sport</TableHeaderColumn>,
                <TableHeaderColumn dataField="team">Game</TableHeaderColumn>,
                <TableHeaderColumn dataField="first">Odds</TableHeaderColumn>,
                <TableHeaderColumn dataField="firstChart">
                  Chart %
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="firstMaster">
                  Master
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="second"></TableHeaderColumn>,
                <TableHeaderColumn dataField="secondChart"></TableHeaderColumn>,
                <TableHeaderColumn dataField="secondMaster"></TableHeaderColumn>,
                <TableHeaderColumn dataField="third"></TableHeaderColumn>,
                <TableHeaderColumn dataField="thirdChart"></TableHeaderColumn>,
                <TableHeaderColumn dataField="thirdMaster"></TableHeaderColumn>,
              ];
            // Soccer
            // MLB
            // MU
            case "mlb":
            case "mu":
            case "soc":
              return [
                <TableHeaderColumn dataField="Id" isKey hidden>
                  Id
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="sport">Sport</TableHeaderColumn>,
                <TableHeaderColumn dataField="team">Game</TableHeaderColumn>,
                <TableHeaderColumn dataField="first">$-Line</TableHeaderColumn>,
                <TableHeaderColumn dataField="firstChart">
                  Chart %
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="firstMaster">
                  Master
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="second">Total</TableHeaderColumn>,
                <TableHeaderColumn dataField="secondChart">
                  Chart %
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="secondMaster">
                  Master
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="third">Side</TableHeaderColumn>,
                <TableHeaderColumn dataField="thirdChart">
                  Chart %
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="thirdMaster">
                  Master
                </TableHeaderColumn>,
              ];

            // nba, cfb, nfl, nhl, cbb
            default:
              return [
                <TableHeaderColumn dataField="Id" isKey hidden>
                  Id
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="sport">Sport</TableHeaderColumn>,
                <TableHeaderColumn dataField="team">Game</TableHeaderColumn>,
                <TableHeaderColumn dataField="first">Spread</TableHeaderColumn>,
                <TableHeaderColumn dataField="firstChart">
                  Chart %
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="firstMaster">
                  Master
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="second">Total</TableHeaderColumn>,
                <TableHeaderColumn dataField="secondChart">
                  Chart %
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="secondMaster">
                  Master
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="third">$-Line</TableHeaderColumn>,
                <TableHeaderColumn dataField="thirdChart">
                  Chart %
                </TableHeaderColumn>,
                <TableHeaderColumn dataField="thirdMaster">
                  Master
                </TableHeaderColumn>,
              ];
          }
        }}
      />
    </div>
  );
}

export default ActionPercentByGame;
